<template>
    <div class="home net-status-home task-container">
        <Layout layoutType="HARDLIST" isRevenue="true" :pageTitle="$t('menu.chooseBusiness')">
            <BasiceLayout :title="$t('menu.matchResources')">
                <div class="margin-20 display-flex">
                    <el-input v-model="searchServerID" placeholder="输入要操作的serverID" style="max-width: 200px"></el-input>
                    <el-dropdown split-button type="primary" @click="handleClick" @command="handleChangeMenu">
                        {{ edit }}
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="MATCH">匹配任务</el-dropdown-item>
                            <el-dropdown-item command="SEARCH">查看部署状态</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-if="isHaveStep">
                    <!-- 验收步骤 -->
                    <el-steps :space="110" align-center :active="activeStep" finish-status="success"
                        :process-status="processStatus">
                        <el-step title="初始化信息" :description="descList[0].desc"></el-step>
                        <el-step title="获取cpu信息" :description="descList[1].desc"></el-step>
                        <el-step title="磁盘压测" :description="descList[2].desc"></el-step>
                        <el-step title="检查线路" :description="descList[3].desc"></el-step>
                        <el-step title="线路压测" :description="descList[4].desc"></el-step>
                        <el-step title="获取内存信息" :description="descList[5].desc"></el-step>
                        <el-step title="检查压测结果" :description="descList[6].desc"></el-step>
                        <el-step :description="descList[7].desc">
                            <template slot="title">
                                <div v-if="isMatch" class="clickStep" @click="taskDialogVisible = true">匹配任务
                                    <el-tooltip class="item" effect="dark" content="点击进行任务选择" placement="bottom">
                                        <i class="el-icon-warning"></i>
                                    </el-tooltip>
                                </div>
                                <div v-else class="disabledClickStep">匹配任务
                                    <el-tooltip class="item" effect="dark" content="无法进行任务选择" placement="bottom">
                                        <i class="el-icon-warning"></i>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-step>
                        <el-step title="部署任务" :description="descList[8].desc"></el-step>
                        <el-step title="验收" :description="descList[9].desc"></el-step>
                    </el-steps>
                </div>
                <!-- 验收信息表格展示 -->
                <el-table v-if="tableData.length" :data="tableData" style="width: 100%; margin-left: 0;">
                    <el-table-column type="expand">
                        <template slot-scope="props">

                            <!-- cpu -->
                            <el-table border v-if="props.row.name == 'cpu' && props.row.info !== 'null'"
                                :data="props.row.info">
                                <el-table-column prop="bcode" label="bcode" width="380">
                                </el-table-column>
                                <el-table-column prop="core" label="core">
                                </el-table-column>
                                <el-table-column prop="physical" label="physical">
                                </el-table-column>
                                <el-table-column prop="processor" label="processor">
                                </el-table-column>
                            </el-table>

                            <!-- 内存 mem -->
                            <el-table border v-if="props.row.name == '内存' && props.row.info !== 'null'"
                                :data="props.row.info">
                                <el-table-column prop="bcode" label="bcode" width="380">
                                </el-table-column>
                                <el-table-column prop="mem_size" label="内存大小">
                                </el-table-column>
                            </el-table>

                            <!-- 带宽压测 speedtest_result -->
                            <el-table border v-if="props.row.name == '带宽压测'  && props.row.info !== 'null'"
                                :data="props.row.info">
                                <el-table-column prop="Account" label="账号">
                                </el-table-column>
                                <el-table-column prop="Bandwidth" label="带宽" width="70">
                                </el-table-column>
                                <el-table-column prop="DataAt" label="时间">
                                </el-table-column>
                                <el-table-column prop="Download" label="Download">
                                </el-table-column>
                                <el-table-column prop="Jitter" label="Jitter">
                                </el-table-column>
                                <el-table-column prop="Operator" label="运营商" width="70">
                                </el-table-column>
                                <el-table-column prop="Ping" label="Ping">
                                </el-table-column>
                                <el-table-column prop="Region" label="地区" width="70">
                                </el-table-column>
                                <el-table-column prop="Upload" label="Upload">
                                </el-table-column>
                                <el-table-column prop="VlanId" label="VlanId">
                                </el-table-column>
                            </el-table>

                            <!-- 磁盘压测 disk_speeds -->
                            <div class="disk-table" v-if="props.row.name == '磁盘压测'">
                                <p>固态硬盘</p>
                                <el-table border v-if="props.row.name == '磁盘压测' && props.row.info !== 'null'"
                                    :data="props.row.info.Ssd">
                                    <el-table-column prop="disk" label="磁盘名称">
                                    </el-table-column>
                                    <el-table-column prop="read_io_kbytes" label="read_io_kbytes">
                                    </el-table-column>
                                    <el-table-column prop="read_iops" label="read_iops">
                                    </el-table-column>
                                    <el-table-column prop="storage_size" label="storage_size">
                                    </el-table-column>
                                    <el-table-column prop="write_io_kbytes" label="write_io_kbytes">
                                    </el-table-column>
                                    <el-table-column prop="write_iops" label="write_iops">
                                    </el-table-column>
                                </el-table>
                                <p>机械硬盘</p>
                                <el-table border :data="props.row.info.Hdd">
                                    <el-table-column prop="disk" label="磁盘名称">
                                    </el-table-column>
                                    <el-table-column prop="read_io_kbytes" label="read_io_kbytes">
                                    </el-table-column>
                                    <el-table-column prop="read_iops" label="read_iops">
                                    </el-table-column>
                                    <el-table-column prop="storage_size" label="storage_size">
                                    </el-table-column>
                                    <el-table-column prop="write_io_kbytes" label="write_io_kbytes">
                                    </el-table-column>
                                    <el-table-column prop="write_iops" label="write_iops">
                                    </el-table-column>
                                </el-table>
                            </div>

                            <!-- 匹配任务失败的原因 task -->
                            <el-table border v-if="props.row.name == '匹配任务失败的原因' && props.row.info !== 'null'"
                                :data="props.row.info">
                                <el-table-column prop="task" label="task">
                                </el-table-column>
                                <el-table-column prop="size" label="size">
                                </el-table-column>
                                <el-table-column prop="cpu_min_process" label="cpu_min_process">
                                </el-table-column>
                                <el-table-column prop="gap_error" label="gap_error">
                                </el-table-column>
                                <el-table-column prop="hdd_min_num" label="hdd_min_num">
                                </el-table-column>
                                <el-table-column prop="hdd_total_min_size" label="hdd_total_min_size">
                                </el-table-column>
                                <el-table-column prop="ipv_6" label="ipv_6">
                                </el-table-column>
                                <el-table-column prop="max_total_band" label="max_total_band">
                                </el-table-column>
                                <el-table-column prop="mem_min_size" label="mem_min_size">
                                </el-table-column>
                                <el-table-column prop="min_frequency" label="min_frequency">
                                </el-table-column>
                                <el-table-column prop="op" label="op">
                                </el-table-column>
                                <el-table-column prop="single_min_band" label="single_min_band">
                                </el-table-column>
                                <el-table-column prop="ssd_min_num" label="ssd_min_num">
                                </el-table-column>
                                <el-table-column prop="ssd_tota_minl_size" label="ssd_tota_minl_size">
                                </el-table-column>
                                <el-table-column prop="total_min_band" label="total_min_band">
                                </el-table-column>
                            </el-table>

                            <!-- 异常信息 errline -->
                            <el-table border v-if="props.row.name == '异常线路' && props.row.info !== 'null'"
                                :data="props.row.info">
                                <el-table-column prop="account" label="账号" width="150">
                                </el-table-column>
                                <el-table-column prop="msg" label="错误信息种类">
                                </el-table-column>
                                <el-table-column prop="errMsg" label="错误信息">
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column label="验收信息" prop="name">
                    </el-table-column>
                </el-table>
                <el-dialog title="可选任务" :visible.sync="taskDialogVisible" width="35%"
                    @before-close="taskDialogVisible = false">
                    <div v-if="matchTaskList.length">
                        <p>请选择：</p>
                        <el-popconfirm title="确定选择此任务吗？" v-for="item in matchTaskList" :key="item.task" :ref="item.task"
                            @confirm="submitTask(item.task)">
                            <el-button slot="reference"
                                style="margin-top: 20px; margin-bottom: 20px;margin-right: 10px;" type="info">{{
                                item.task }}</el-button>
                        </el-popconfirm>
                    </div>
                    <div v-else>
                        <el-empty :image-size="50"></el-empty>
                    </div>
                </el-dialog>
            </BasiceLayout>
        </Layout>
    </div>
</template>

<script>
    import moment from "moment";
    import { Message } from "element-ui";
    import { mapActions } from "vuex";
    import BasiceLayout from "@/components/Common/BasicLayout.vue";
    import Layout from "@/components/DatePanel/Layout.vue";

    export default {
        name: "home",
        components: {
            BasiceLayout,
            Layout
        },
        data() {
            return {
                gapList: [],
                tableData: [],
                matchTaskList: [],
                searchServerID: '',
                processStatus: "wait",
                edit: '选择操作',
                activeStep: 0,
                taskDialogVisible: false,
                isMatch: false,
                isHaveStep: false,
                descList: [
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                    { desc: '' },
                ]
            }
        },
        methods: {
            ...mapActions([
                "getDeviceAcceptance",
                "setDeviceAcceptance",
                "setDeviceDeployment"
            ]),
            async submitTask(task) {
                const res = await this.setDeviceDeployment({ server_id: this.searchServerID, task });
                if (res.code == 200) {
                    Message.success('操作成功');
                    this.taskDialogVisible = false;
                } else {
                    Message.error(res.message || '任务选择失败')
                }
            },
            async getAcceptanceList() {
                try {
                    this.tableData = [];
                    this.descList = [
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                        { desc: '' },
                    ];
                    this.isHaveStep = false;
                    const res = await this.getDeviceAcceptance({ server_id: this.searchServerID });

                    if (res.code == 200) {
                        const { status, message, step } = res.task_schedule;
                        if (status && step) {
                            this.isHaveStep = true;
                        }
                        this.activeStep = Number(step);
                        this.isMatch = this.activeStep < 7 || (this.activeStep == 7 && status == 'stop') ? false : true;
                        this.processStatus = status == 'stop' ? 'error' : 'process';
                        if (this.activeStep < 10) {
                            this.descList[this.activeStep].desc = message;
                        }
                        if (res.match_task && res.match_task.length) {
                            this.matchTaskList = res.match_task;
                        }
                        res.data.forEach(item => {
                            for (var key in item) {
                                let name = '';
                                if (key == 'disk_speeds') {
                                    name = '磁盘压测'
                                } else if (key == 'speedtest_result') {
                                    name = "带宽压测"
                                    if (item[key] && item[key].length) {
                                        item[key].forEach(speedItem => {
                                            return speedItem.DataAt = moment(speedItem.DataAt).format('YYYY-MM-DD HH:mm:ss')
                                        })
                                    }
                                } else if (key == 'mem') {
                                    name = "内存"
                                } else if (key == 'cpu') {
                                    name = 'cpu'
                                } else if (key == 'task') {
                                    name = '匹配任务失败的原因'
                                } else if (key == 'errLine') {
                                    name = '异常线路'
                                }

                                if (item[key]) {
                                    const tableItem = {
                                        name,
                                        info: item[key]
                                    }
                                    this.tableData.push(tableItem);
                                }
                            }
                        })
                    } else {
                        Message.error(res.message || '获取设备验收信息失败，请重试')
                    }
                } catch (error) {
                    return Message.error(`获取设备验收信息失败(${error})`);
                }
            },
            async handleClick() {
                if (this.edit == "选择操作") return Message.error('请下拉选择要进行的操作');
                if (!this.searchServerID) return Message.error('请输入要操作的 serverID');
                if (this.edit == '匹配任务') {
                    this.tableData = [];
                    const res = await this.setDeviceAcceptance({ server_id: this.searchServerID })
                    res.code == 200 ? Message.success(res.message) : Message.error(res.message || '匹配任务失败，请重试');
                } else if (this.edit == '查看部署状态') {
                    this.getAcceptanceList();
                }
            },
            handleChangeMenu(val) {
                this.edit = val == 'MATCH' ? '匹配任务' : '查看部署状态';
            },

        }
    };
</script>

<style scoped lang="stylus">
    .task-container {
        .el-dropdown {
            margin-left: 10px;
        }

        .el-steps--horizontal {
            padding: 20px;
            box-sizing: border-box;
        }

        .el-table {
            padding: 20px;
            box-sizing: border-box;
        }

        .clickStep {
            cursor: pointer;
        }

        .disabledClickStep {
            cursor: not-allowed;
        }

        .el-table {
            width: 90%;
            margin-left: 60px;
        }

        .disk-table {
            width: 90%;
            margin-left: 60px;
            text-align: center;

            p {
                color: #909399;
                margin: 30px 0 10px 0;
            }

            p:nth-child(1) {
                margin: 10px 0;
            }

            .el-table {
                width: 100%;
                margin-left: 0;
            }
        }
    }
</style>

<style>
    .el-popconfirm__main {
        padding-bottom: 10px !important;
    }

    .el-step__description.is-error {
        word-break: break-all;
    }

    .el-step__description.is-process {
        word-break: break-all;
    }
</style>